import { Injectable } from "@angular/core";
import { PostgRestObject } from "../databases/postgrest.database";
import { CHDbObject, DbObject } from "../model/db-object.model";

type DbObjectType = PostgRestObject | DbObject | CHDbObject;

export type ImportMap<T extends DbObjectType, D extends DbObjectType> = Readonly<
    {
        i: keyof D;
        o: keyof T;
        skipExport?: boolean;
    }[]
>;

@Injectable({
    providedIn: "root",
})
export class ClassImporterExporter {
    static exportObject<T extends DbObjectType, D extends DbObjectType>(
        entity: T,
        importMap: ImportMap<T, D>,
        includeNullValues: boolean = true
    ): D {
        const json = {} as D;

        for (const prop of importMap) {
            if (entity.hasOwnProperty(prop.o)) {
                const property = entity[prop.o] as any;

                if (prop.skipExport || (prop.i === "id" && !property)) {
                    continue;
                }

                if (includeNullValues) {
                    if (property !== undefined && property !== "") {
                        json[prop.i] = property as D[keyof D];
                    } else {
                        json[prop.i] = null;
                    }
                } else if (property !== undefined && property !== null) {
                    json[prop.i] = property as D[keyof D];
                }
            }
        }

        return json;
    }

    static importObject<T extends DbObjectType, D extends DbObjectType>(entity: D, importMap: ImportMap<T, D>): T {
        const newEntity = {} as T;
        if (entity) {
            for (const prop of importMap) {
                if (entity.hasOwnProperty(prop.i)) {
                    const property = entity[prop.i] as any;
                    newEntity[prop.o] = property as T[keyof T];
                } else {
                    // console.warn(`Property ${String(prop.i)} does not exist on`, entity);
                }
            }
        } else {
            // console.error("No data to import");
        }
        return newEntity;
    }
}
